import React, { useState } from 'react';
import { styled } from '../../../stitches.config';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Box from '../Box';
import useMediaQuery from "../../../helpers/useMediaQuery";


// icons 
import ArrowLeft from '../../../assets/img/mamadu/carrefour/ArrowLeft.png'
import ArrowRight from '../../../assets/img/mamadu/carrefour/ArrowRight.png'

// img
import undelineTextMobile from '../../../assets/img/natemat/minisite/MS-3-text-underline-mobile.png';
import textMobile from '../../../assets/img/natemat/minisite/MS-3-text-mobile.png';
import imgLeft from '../../../assets/img/natemat/minisite/MS-3-img-left-desktop.png';
import imgRight from '../../../assets/img/natemat/minisite/MS-3-img-right-desktop.png';
import logo from '../../../assets/img/natemat/minisite/MS-3-logo.png';
import backgroundMobile from '../../../assets/img/natemat/minisite/MS-3-background-mobile.png';
import backgroundDesktop from '../../../assets/img/natemat/minisite/MS-3-background-desktop.jpg';

// strzałki do slidera

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <CustomArrow
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <img src={ArrowRight} />
        </CustomArrow>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <CustomArrow
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <img src={ArrowLeft} />
        </CustomArrow>
    );
}

// losowe ustawienie slidów

const shuffleCards = (number) => (cards) => {
    const array = Object.keys(cards).map(k => cards[k]);
    let currentIndex = array.length, randomIndex;

    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
    const obj = array.reduce((acc, curr, i) => (acc[`b${i + number}`] = curr, acc), {})

    return obj
}

const shuffleCardsMobile = shuffleCards(1)

export default props => {

    const isDesktop = useMediaQuery('bp4');

    const [mobileCards] = useState(() => shuffleCardsMobile([props.settings.b1, props.settings.b2, props.settings.b3, props.settings.b4]))
    const settings = {
        infinite: true,
        dots: true,
        arrows: true,
        speed: 500,
        // uwzględniać 3 lub 4 slidesToShow razem z poniższym komentarzem
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                // uwzględniać ten breakpoint gdy mają być widoczne 4 slidy na dekstopie
                breakpoint: 1310,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true,
                    dots: true,
                }
            },
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "45px",
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "70px",
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "50px",
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "20px",
                }
            }
        ]
    };
    return (
        <Section>
            <Wrapper>

                <Logo>
                    <img src={logo} className="logo mobile" />
                    <img src={imgLeft} className="img-left desktop" />
                    <img src={imgRight} className="img-right desktop" />
                    <img src={textMobile} className="text-mobile mobile" />
                    <img src={undelineTextMobile} className="underline-text-mobile mobile" />
                </Logo>

                {isDesktop ?
                    <CarouselWrapper>
                        <Slider {...settings}>
                            <Box {...props}
                                id="b1"
                                type="AMiniSite"
                                settings={props.settings.b1}
                            />
                            <Box {...props}
                                id="b2"
                                type="AMiniSite"
                                settings={props.settings.b2}
                            />
                            <Box {...props}
                                id="b3"
                                type="AMiniSite"
                                settings={props.settings.b3}
                            />
                            <Box {...props}
                                id="b4"
                                type="AMiniSite"
                                settings={props.settings.b4}
                            />
                        </Slider>
                    </CarouselWrapper>
                    :
                    <BoxWrapper>
                        <Box {...props}
                            id="b1"
                            type="AMiniSite"
                            settings={props.settings.b1}
                        />
                        <Box {...props}
                            id="b2"
                            type="AMiniSite"
                            settings={props.settings.b2}
                        />
                        <Box {...props}
                            id="b3"
                            type="AMiniSite"
                            settings={props.settings.b3}
                        />
                        <Box {...props}
                            id="b4"
                            type="AMiniSite"
                            settings={props.settings.b4}
                        />
                    </BoxWrapper>
                }
            </Wrapper>
        </Section>
    );
}

// slider

const CustomArrow = styled("div", {
    "img": {
        width: "43px",
        height: "43px",
        margin: "auto",
        position: "absolute",
        top: "-10px",
        left: "0"
    }
});

const CarouselWrapper = styled("div", {
    marginBottom: "55px",
    overflow: "visible",
    ".slick-list": {
        marginBottom: "50px",
        "@bp4": {
            marginBottom: "0px",
            padding: "10px 0px"
        }
    },
    ".slick-slide": {
        "& > div": {
            display: "grid",
            placeItems: "center"
        }
    },
    ".slick-arrow": {
        zIndex: 10
    },
    ".slick-prev": {
        left: "380px",
        top: "382px",
        "@bp5": {
            left: "530px",
        }
    },
    ".slick-next": {
        right: "410px",
        top: "382px",
        "@bp5": {
            right: "560px",
        }
    },
    ".slick-dots": {
        bottom: "-35px",
        "li": {
            margin: "0",
            width: "18px",
            height: "9px",
            "&.slick-active": {
                button: {
                    "&:before": {
                        /* main kolor minisite */
                        color: "#f06301",
                        opacity: 1,
                        "@bp4": {
                            borderRadius: "10px"
                        }
                    }
                }
            },
            button: {
                width: "9px",
                height: "9px",
                padding: "0",
                "&:before": {
                    width: "9px",
                    height: "9px",
                    fontSize: "9px",
                    lineHeight: "9px",
                    color: "white",
                    opacity: 1,
                    "@bp4": {
                        borderWidth: "0px",
                        borderRadius: "10px"
                    }
                }
            }
        }
    }
});

const Section = styled("div", {
    overflow: "hidden",
    width: "100%",
    paddingBottom: "1px",
    backgroundColor: "#000",
    backgroundImage: `url("${backgroundMobile}")`,
    backgroundPosition: "top center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "584px",
    position: "relative",
    "@media(min-width: 550px)": {
        backgroundSize: "750px",
    },
    "@bp4": {
        backgroundPosition: "calc(50% + 85px) top",
        backgroundImage: `url("${backgroundDesktop}")`,
        height: "580px",
        backgroundSize: "cover",
    },
    "@bp5": {
        backgroundPosition: "top center",
        height: "580px",
        backgroundSize: "auto",
    },
    ".desktop": {
        display: "none",
        "@bp4": {
            display: "block"
        }
    },
    ".mobile": {
        "@bp4": {
            display: "none"
        }
    },
    ".img-background": {
        marginTop: "-70px",
        width: "400px",
        "@bp4": {
            marginTop: "0px",
            position: "absolute",
            top: "-55px",
            width: "980px",
        },
        "@bp5": {
            width: "1320px",
        }
    }
});

const Wrapper = styled("div", {
    width: "100%",
    margin: "0 auto",
    paddingTop: "400px",
    paddingBottom: "40px",
    "@media(min-width: 550px)": {
        paddingTop: "490px",
    },
    "@bp4": {
        paddingTop: "160px",
        paddingBottom: "0px",
        flexDirection: "row",
        maxWidth: "972px",
        justifyContent: "space-between",
        alignItems: "flex-start"
    },
    /* ustawiać ten breakpoint gdy są 4 slidy na dekstopie 
    @media only screen and (min-width: 1370px) {
        max-width: 1266px;
    } */
    "@bp5": {
        paddingTop: "242px",
        maxWidth: "1280px",
        paddingTop: "212px",
    },
    "h1": {
        fontSize: "30px",
        lineHeight: "38px",
        color: "#D7141A",
        textAlign: "center",
        paddingTop: "10px",
        margin: "0",
        fontWeight: 800,
        fontFamily: "$grotesk",
        position: "relative",
        "@bp4": {
            marginBottom: "0px",
            fontSize: "34px",
            lineHeight: "42px"
        }
    },
    ".h1-bold": {
        color: "#242424",
        marginBottom: "0px",
        paddingTop: "10px",
        "@bp4": {
            paddingTop: "0",
            marginBottom: "185px"
        }
    },
});


const Logo = styled("div", {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    position: "absolute",
    top: "0",
    left: "0",
    "@bp4": {
        top: "0",
        left: "0",
        width: "100%",
        marginTop: "50px"
    },
    ".logo": {
        marginTop: "20px",
        width: "60px",
        position: "relative",
        zIndex: 5,
    },
    ".img-left": {
        "@bp4": {
            position: "absolute",
            width: "100px",
            marginTop: "78px",
            marginLeft: "-835px",
        },
        "@bp5": {
            width: "130px",
            marginTop: "130px",
            marginLeft: "-1100px",
        },
    },
    ".img-right": {
        "@bp4": {
            position: "absolute",
            width: "220px",
            marginTop: "88px",
            marginLeft: "740px",
        },
        "@bp5": {
            width: "380px",
            marginTop: "120px",
            marginLeft: "740px",
        },
    },
    ".text-mobile": {
        width: "300px",
        marginTop: "20px",
        "@media(min-width: 550px)": {
            width: "340px",
        },
    },
    ".underline-text-mobile": {
        width: "320px",
        marginTop: "120px",
        "@media(min-width: 550px)": {
            marginTop: "200px",
        },
    },
});


const BoxWrapper = styled("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    gap: "24px",
    position: "relative",
    zIndex: 5,
    "@bp4": {
        flexDirection: "row"
    },
});